import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetHealthSpecialtiesLocalities,
	GetHealthSpecialtiesLocalitiesModel,
	GetHealthSpecialtiesLocalitiesParams,
} from 'domain/usecases/private/booking-flow/health';

export class RemoteGetHealthSpecialtiesLocalities implements GetHealthSpecialtiesLocalities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthSpecialtiesLocalitiesModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthSpecialtiesLocalitiesParams): Promise<GetHealthSpecialtiesLocalitiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
